import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { useAppEnvConfig, useSocket } from './feature';

export const useAppAuthenticatedInitializer = () => {
  const { appConfig, env } = useAppEnvConfig();
  const { connectSocket, initializeSocket } = useSocket();

  const queryClient = useQueryClient();

  useEffect(() => {
    const timer = setInterval(() => {
      queryClient.invalidateQueries();
    }, 300000); // 5 minutes
    return () => clearInterval(timer);
  }, [queryClient]);

  useEffect(() => {
    if (appConfig.account && env?.connectServiceApiHost) {
      initializeSocket({ appConfig, connectServiceApiHost: env.connectServiceApiHost });
      connectSocket();
    }
  }, [appConfig, connectSocket, env?.connectServiceApiHost, initializeSocket]);
};
